var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransfe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_89_257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.7501 -2.85504C37.5596 0.622419 35.3217 3.17924 34.0362 4.81543C32.8013 6.38737 31.2585 8.64274 29.4078 11.5815L32.1937 24.9714C33.2848 25.1067 37.4869 26.0375 38.6783 26.0949C46.7926 26.4878 48.3145 23.6202 48.5564 23.5128C48.6023 23.2518 49.4996 18.3002 47.1909 10.5194C45.7813 5.74234 43.6061 1.22553 40.7501 -2.85504Z",
    fill: "url(#paint0_radial_89_257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.405 11.5815L40.7472 -2.85504C36.1068 -4.6642 31.2037 -5.70868 26.2288 -5.9478C18.1229 -6.34933 13.524 -4.3059 13.2821 -4.19923C13.2349 -3.93904 11.8131 1.16077 14.1154 8.95201C14.444 10.0497 15.3316 10.972 15.7364 12.044L29.405 11.5815Z",
    fill: "url(#paint1_radial_89_257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.2886 -4.19849L0.217398 12.3082C0.169398 12.568 -0.731174 17.5047 1.57073 25.2962C2.58753 28.7023 3.97661 31.986 5.71283 35.0878L18.2395 17.5876C16.7533 14.7806 15.5483 11.8336 14.642 8.78951C12.3397 0.998085 13.2404 -3.9383 13.2886 -4.19849Z",
    fill: "url(#paint2_linear_89_257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M48.5557 23.5143C48.3146 23.6217 43.7313 25.6659 35.6161 25.2728C32.4424 25.1125 29.2923 24.6388 26.2119 23.8585L12.1763 40.1659C15.6011 41.1191 19.1206 41.6915 22.6709 41.8729C30.7852 42.2661 35.3687 40.2225 35.6104 40.115L48.5557 23.5143Z",
    fill: "url(#paint3_linear_89_257)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_89_257",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1908.61 -724.041) scale(5403.14 5403.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#FA9B68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0465A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_89_257",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1779.93 1935.54) scale(5988.34 5988.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#FBAB69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#F27B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F06E5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_89_257",
    x1: -89.3491,
    y1: -1634.58,
    x2: 3580.67,
    y2: 1317.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#1458E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#2C77EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#3F8EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#4C9FF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#54A9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ADF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_89_257",
    x1: 4566.88,
    y1: 943.956,
    x2: -1650.36,
    y2: 943.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#1E64E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#3C8BF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#4FA4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57ADF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.77,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfe);
export default __webpack_public_path__ + "static/media/transfe.31a1ca1329e5f578a1e90cd85891f2d0.svg";
export { ForwardRef as ReactComponent };